"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSwitchOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22.29 13.29l1.42 1.42 5.7-5.72-5.7-5.7-1.42 1.42L25.59 8H4v2h21.58l-3.29 3.29zM9.71 17.71l-1.42-1.42-5.7 5.72 5.7 5.7 1.42-1.42L6.41 23l21.59.01v-2L6.42 21l3.29-3.29z" })));
}
exports.default = SvgSwitchOutline;
//# sourceMappingURL=SwitchOutline.js.map